<template>
  <div ref="container">
    <div style="height: 20vh;background: #e9c7a0;display: flex">
      <div v-if="$route.query && $route.query.showTitle"
           style="margin-top: 3.5vh;margin-left: 3vw;height: 3vh;display: flex;align-items: center;"
           @click="$router.back()">
        <img src="../../assets/images/back.png" style="width: 3vh;height: 3vh">
        <span style="font-size: 3vh;font-weight: 700;color: #dc6666;text-align: left;vertical-align: top;">{{
            $route.meta && $route.meta.title || ''
          }}</span>
      </div>
    </div>
    <div class="commentsItem" @click="print">

      <div class="assessment">
        <img
            :src="ossOriImgUrl"
            alt=""
        />
        <div class="col9 pt30">舌面原图矫正图</div>
      </div>

      <div class="assessment">
        <img
            :src="ossSplitImgUrl"
            alt=""
        />
        <div class="col9 pt30">舌面分割图</div>
      </div>

      <div class="assessment">
        <img
            :src="ossSplitBackImgUrl"
            alt=""
        />

        <div class="col9 pt30">舌面原图矫正图</div>
      </div>
    </div>
    <div class="glossoscopyList" style="margin-top: -80px">
      <div ref="list" style="margin-top: 80px">
        <div style="width: 100%;display: flex;align-items: center;justify-content: center">
          <div id="main" :style="{ width: `${chartWidth}px`,height:`${chartWidth}px` }"></div>
        </div>

        <div style="width: 100%;display: flex;align-items: center;justify-content: center">
          <div id="main2" :style="{ width: `${chartWidth}px`,height:`${chartWidth}px` }"></div>
        </div>
        <div class="fz24" style="margin-top: 20px" v-html="veinDescribe"/>
      </div>
    </div>

    <div style="width: 100%;display: flex;align-items: center;justify-content: center">
      <div id="main3" :style="{ width: `${chartWidth}px`,height:`${chartWidth/2}px` }"></div>
    </div>

    <div class="glossoscopy">
      <div class="glossoscopyList">
        <div class="glossoscopytitle_one">
          <!-- <img src="../../assets/images/assessment1.png" class="glossoscopytex" alt=""> -->
          <img alt="" class="glossoscopytex" src="../../assets/images/item_icon1.png">
          <span class="glossoscopytitle">津液</span>
        </div>
        <div class="glossoscopytitle_two">{{ bodyfluidNames }}</div>
        <span class="fz24" v-html="bodyfluidDescribe"
        ></span
        >
      </div>
      <div class="glossoscopyList">
        <div class="glossoscopytitle_one">
          <img alt="" class="glossoscopytex" src="../../assets/images/item_icon2.png">
          <span class="glossoscopytitle">苔色</span>
        </div>
        <div class="glossoscopytitle_two">{{ colorOfMossNames }}</div>
        <span class="fz24" v-html="colorOfMossDescribe"></span
        >
      </div>
      <div class="glossoscopyList">
        <div class="glossoscopytitle_one">
          <img alt="" class="glossoscopytex" src="../../assets/images/item_icon3.png">
          <span class="glossoscopytitle">舌色</span>
        </div>
        <div class="glossoscopytitle_two">{{ colorOfTongueNames }}</div>
        <span class="fz24" v-html="colorOfTongueDescribe"/>
      </div>

      <div class="glossoscopyList">
        <div class="glossoscopytitle_one">
          <img alt="" class="glossoscopytex" src="../../assets/images/item_icon4.png">
          <span class="glossoscopytitle">苔质</span>
        </div>
        <div class="glossoscopytitle_two">{{ mossNames }}</div>
        <span class="fz24" v-html="mossDescribe"/>
      </div>

      <div class="glossoscopyList">
        <div class="glossoscopytitle_one">
          <img alt="" class="glossoscopytex" src="../../assets/images/item_icon5.png">
          <span class="glossoscopytitle">舌形</span>
        </div>
        <div class="glossoscopytitle_two">{{ shapeOfTongueNames }}</div>
        <span class="fz24" v-html="shapeOfTongueDescribe"/>
      </div>

      <div class="glossoscopyList">
        <div class="glossoscopytitle_one">
          <img alt="" class="glossoscopytex" src="../../assets/images/item_icon6.png">
          <span class="glossoscopytitle">络脉</span>
        </div>
        <div class="glossoscopytitle_two">{{ veinNames }}</div>
        <span class="fz24" v-html="veinDescribe"/>
      </div>


      <div class="glossoscopyList">
        <div class="glossoscopytitle_one">
          <img alt="" class="glossoscopytex" src="../../assets/images/item_icon7.png">
          <span class="glossoscopytitle">易患病症</span>
        </div>

        <div class="body-type-view">
          <div class="body-type-view__side body-type-view__side--left">
            <div
                v-for="(item, index) in types[0]"
                :key="index"
                class="body-type-view__btn"
            >
              {{ item }}
            </div>
          </div>

          <div class="body-type-view__center">
            <img src="../../assets/images/symptoms.png" alt="人体图" class="body-type-view__human"/>
          </div>

          <div class="body-type-view__side body-type-view__side--right">
            <div
                v-for="(item, index) in types[1]"
                :key="index"
                class="body-type-view__btn"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <div v-for="(care,cares) in predisposition" :key="cares">
          <div class="explain">说明</div>
          <span class="fz24">{{ care.message }}</span>
          <div v-for="(item,itemvalue) in care.items" :key="itemvalue">
            <div class="Recuperation">
              <img :src="item.photo" alt="">
              <span class="pl30 fz28">{{ item.name }}<br/>
                        <span class=" fz20" v-html="item.desc"/>
                        </span>
            </div>
          </div>
        </div>
      </div>


      <div class="glossoscopyList">
        <div class="glossoscopytitle_one">
          <img alt="" class="glossoscopytex" src="../../assets/images/item_icon8.png">
          <span class="glossoscopytitle">主要表现</span>
        </div>

        <div v-for="(care,cares) in main_performance" :key="cares">
          <div class="explain">说明</div>
          <span class="fz24">{{ care.message }}</span>
          <div v-for="(item,itemvalue) in care.items" :key="itemvalue">
            <div class="Recuperation">
              <img :src="item.photo" alt="">
              <span class="pl30 fz28">{{ item.name }}<br/>
                        <span class=" fz20" v-html="item.desc"/>
                        </span>
            </div>
          </div>
        </div>
      </div>

      <div class="glossoscopyList">
        <div class="glossoscopytitle_one">
          <img alt="" class="glossoscopytex" src="../../assets/images/item_icon9.png">
          <span class="glossoscopytitle">发生原因</span>
        </div>

        <div v-for="(care,cares) in occur_reason" :key="cares">
          <div class="explain">说明</div>
          <span class="fz24">{{ care.message }}</span>
          <div v-for="(item,itemvalue) in care.items" :key="itemvalue">
            <div class="Recuperation">
              <img :src="item.photo" alt="">
              <span class="pl30 fz28">{{ item.name }}<br/>
                        <span class=" fz20" v-html="item.desc"/>
                        </span>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>
<script>
import axios from 'axios'
import {getFixedConstitutionScore} from '../../utils/yinyang'
import html2canvas from "html2canvas";

let color1 = "#EB5F5F";
let color2 = "#FFB64D";

function generateGradientColors(steps) {
  // 解析颜色为 RGB
  function hexToRgb(hex) {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);
    return {r, g, b};
  }

  // 将 RGB 转换为 HEX
  function rgbToHex(r, g, b) {
    return `#${(1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1).toUpperCase()}`;
  }

  let rgb1 = hexToRgb(color1);
  let rgb2 = hexToRgb(color2);
  let gradient = [color1];

  // 计算渐变色
  for (let i = 1; i <= steps - 2; i++) {
    let r = Math.round(rgb1.r + (rgb2.r - rgb1.r) * (i / (steps - 1)));
    let g = Math.round(rgb1.g + (rgb2.g - rgb1.g) * (i / (steps - 1)));
    let b = Math.round(rgb1.b + (rgb2.b - rgb1.b) * (i / (steps - 1)));

    gradient.push(rgbToHex(r, g, b));
  }
  gradient.push(color2)
  return gradient;
}

function parseSymptoms(text) {
  console.error('原文本:', text);
  // 匹配所有以“易患”开头到句号或换行或结尾的内容
  const matches = [...text.matchAll(/易患([^\n。]*)/g)];
  if (!matches.length) return [];

  const result = matches.map(m => {
    let raw = m[1];
    // 去掉“等病”、“等病症”、“等疾病”等尾巴
    raw = raw.replace(/等病症?|等疾病?|等病/g, '');

    // 按常见分隔符拆分
    const list = raw.split(/[、，,或]/).map(s => s.trim()).filter(Boolean);

    const half = Math.ceil(list.length / 2);
    return [
      list.slice(0, half) || [],
      list.slice(half) || []
    ];
  });

  console.error('匹配结果（二维数组）:', result);
  return result[0];
}

export default {
  name: 'Healthy',
  data() {
    return {
      chartWidth: 400,
      bodyfluidNames: '',
      bodyfluidDescribe: '',
      colorOfMossNames: '',
      colorOfMossDescribe: '',
      colorOfTongueNames: '',
      colorOfTongueDescribe: '',
      mossNames: '',
      mossDescribe: '',
      shapeOfTongueNames: '',
      shapeOfTongueDescribe: '',
      veinNames: '',
      veinDescribe: '',
      constitutionNames: '',
      constitutionDescribe: '',
      singleConfigName: '',
      ossOriImgUrl: '',
      ossSplitImgUrl: '',
      ossSplitBackImgUrl: '',
      diagnostic_results: '',
      br: '',
      loading: false,
      finished: true,
      sports_health_care: [{
        message: '',
        items: [{
          name: '',
          photo: '',
          desc: ''
        }]
      }],
      diet_rehabilitation: [{
        message: '',
        items: [{
          name: '',
          photo: '',
          desc: ''
        }]
      }],
      predisposition: [{
        message: '',
        items: [{
          name: '',
          photo: '',
          desc: ''
        }]
      }],
      massage_health_care: [
        {
          message: '',
          items: [{
            name: '',
            photo: '',
            desc: ''
          }]
        }
      ],
      main_performance: [
        {
          message: '',
          items: [{
            name: '',
            photo: '',
            desc: ''
          }]
        }
      ],
      occur_reason: [
        {
          message: '',
          items: [{
            name: '',
            photo: '',
            desc: ''
          }]
        }
      ],
      drug_health_care: [
        {
          message: '',
          items: [{
            name: '',
            photo: '',
            desc: ''
          }]
        }
      ],
      recuperates: [
        {
          message: '',
          items: [{
            name: '',
            photo: '',
            desc: ''
          }]
        }
      ],
      types: [[], []],
      yinyang: [50, 50]
    }
  },
  created() {
    // document.title = '舌诊评估'
    console.log(this.$route.query)
    this.id = this.$route.query.id
  },
  mounted() {
    let width = window.innerWidth * 0.7
    if (width < 400) {
      width = Math.min(400, window.innerWidth)
    }
    width = Math.min(width, this.$refs.list.clientWidth)
    this.chartWidth = width
    console.error(this.chartWidth)
    this.getcode(this.id)
  },
  methods: {
    getcode(id) {
      let url = `${this.baseUrl}/app/details?id=${id}`
      this.br = '<br/>'
      axios.post(url)
          .then((result) => {
            console.log(result)
            let details = result.data.userDetails
            this.bodyfluidNames = details.bodyfluidnames
            this.bodyfluidDescribe = details.bodyfluiddescribe
            this.colorOfMossNames = details.colorofmossnames
            this.colorOfMossDescribe = details.colorofmossdescribe
            this.colorOfTongueNames = details.coloroftonguenames
            this.colorOfTongueDescribe = details.coloroftonguedescribe
            this.colorOfTongueDescribe = details.coloroftonguedescribe
            this.mossNames = details.mossnames
            this.mossDescribe = details.mossdescribe
            this.shapeOfTongueNames = details.shapeoftonguenames
            this.shapeOfTongueDescribe = details.shapeoftonguedescribe
            this.shapeOfTongueDescribe = details.shapeoftonguedescribe
            this.veinNames = details.veinnames
            this.veinDescribe = details.veindescribe
            this.constitutionNames = details.constitutionnames
            this.constitutionDescribe = details.constitutiondescribe
            this.singleConfigName = details.singleconfigname

            this.ossOriImgUrl = details.ossoriimgurl
            this.ossSplitImgUrl = details.osssplitimgurl
            this.ossSplitBackImgUrl = details.osssplitbackimgurl
            let json = JSON.parse(details.treatplanjson)
            console.log(json)
            this.diagnostic_results = json[0] && json[0].diagnostic_results
            if (this.diagnostic_results == null || this.diagnostic_results == '') {
              this.diagnostic_results = this.singleConfigName || this.constitutionNames
            }
            console.error(this.diagnostic_results)
            this.sports_health_care = json[0] && json[0].sports_health_care
            this.diet_rehabilitation = json[0] && json[0].diet_rehabilitation
            this.predisposition = json[0] && json[0].predisposition || [{message: json.predisposition}]
            console.error(this.predisposition)
            this.massage_health_care = json[0] && json[0].massage_health_care
            this.main_performance = json[0] && json[0].main_performance || [{message: json.mainPerformance}]
            this.occur_reason = json[0] && json[0].occur_reason || json.occurReason && json.occurReason.map(item => {
              return {
                message: item
              }
            })
            this.drug_health_care = json[0] && json[0].drug_health_care
            this.recuperates = json[0] && json[0].recuperates
            this.renderCharts1(this.diagnostic_results)
            this.renderCharts2(this.diagnostic_results)
            this.renderChart3(this.diagnostic_results)
            this.renderSymptoms()
            // this.renderYinYang()
          }).catch(error => {
        //this.$router.replace("error")
      })
    },
    renderCharts1(result) {
      const echarts = this.$echarts

      const circleRadius = this.chartWidth / 4
      const greenRadius = this.chartWidth / 3
      const wordRadius = this.chartWidth / 3 + 10
      const center = this.chartWidth / 2
      const lineWidth = this.chartWidth / 32
      const polygonWidth = this.chartWidth / 20

      const labels = [
        '特禀',
        '阳虚',
        '阴虚',
        '气虚',
        '气滞',
        '痰湿',
        '血瘀',
        '血虚',
        '平和',
      ];
      const currentIndex = this.calcIndex(labels, result)
      console.error('currentIndex', currentIndex)
      const total = labels.length;
      const slice = 300 / total;
      const startAngle = 240, endAngle = 300

      const deg1 = startAngle - slice * currentIndex - slice / 2;
      // console.error(deg1)
      const rad1 = deg1 * Math.PI / 180;
      const r1 = circleRadius - 3;
      const rotation1 = rad1 + Math.PI * 3 / 2;

      const steps = Math.ceil(labels.length / 2)
      const colors = generateGradientColors(steps)
      const colorIndex = currentIndex < steps ? currentIndex : (labels.length - 1 - currentIndex)
      // console.error(colorIndex)
      const polygonColor = colors[colorIndex];
      // console.error(polygonColor)
      const option = {
        backgroundColor: '#fff',
        series: [
          {
            name: 'arc',
            type: 'gauge',
            radius: greenRadius,
            startAngle,
            endAngle,
            axisLine: {
              lineStyle: {
                width: lineWidth,
                color: [[1, '#E0E0E080']]
              }
            },
            progress: {show: false},
            axisTick: {show: false},
            splitLine: {show: false},
            axisLabel: {show: false},
            pointer: {show: false},
            anchor: {show: false},
            detail: {show: false}
          },
          {
            name: 'green',
            type: 'gauge',
            radius: greenRadius,
            startAngle: startAngle - slice * currentIndex,
            endAngle: startAngle - slice * (currentIndex + 1),
            axisLine: {
              roundCap: true,
              lineStyle: {
                width: currentIndex >= 0 ? lineWidth : 0,
                color: [[1, '#56D173']]
              }
            },
            progress: {show: false},
            axisTick: {show: false},
            splitLine: {show: false},
            axisLabel: {show: false},
            pointer: {show: false},
            anchor: {show: false},
            detail: {show: false}
          }
        ],
        graphic: [
          {
            type: 'circle',
            left: 'center',
            top: 'center',
            shape: {r: circleRadius},
            style: {
              fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {offset: 0, color: '#FFB64D'},
                {offset: 1, color: '#EB5F5F'}
              ])
            }
          },
          {
            type: 'text',
            left: 'center',
            top: 'center',
            style: {
              text: `${result}\n体质`,
              textAlign: 'center',
              textVerticalAlign: 'middle',
              fontSize: 24,
              fontWeight: 'bold',
              fill: '#fff'
            }
          },
          // 小箭头旋转定位到高亮位置
          {
            type: 'polygon',
            shape: {
              points: [
                [0, -polygonWidth], [-polygonWidth, 0], [polygonWidth, 0]
              ]
            },
            position: [center + r1 * Math.cos(rad1), center - r1 * Math.sin(rad1)],
            rotation: rotation1,
            style: {
              fill: polygonColor
            }
          },
          ...labels.map((label, i) => {
            const deg = startAngle - slice * i - slice / 2;
            const rad = deg * Math.PI / 180;
            const r = wordRadius;
            return {
              type: 'group',
              position: [center + r * Math.cos(rad), center - r * Math.sin(rad)],
              rotation: rad + Math.PI * 3 / 2,
              children: [
                {
                  type: 'text',
                  style: {
                    text: label,
                    fontSize: this.clientWidth > 400 ? 30 : 16,
                    fill: '#333333a0',
                    textAlign: 'center',
                    textVerticalAlign: 'bottom'
                  },
                  position: [0, 0]
                }
              ]
            };
          })
        ]
      };

      const chart = echarts.init(document.getElementById('main'));
      chart.setOption(option);

    },
    renderCharts2(result) {
      // console.error(result)
      const echarts = this.$echarts

      const circleRadius = this.chartWidth / 4
      const greenRadius = this.chartWidth / 3
      const wordRadius = this.chartWidth / 3 + 10
      const center = this.chartWidth / 2
      const lineWidth = this.chartWidth / 32
      const polygonWidth = this.chartWidth / 20

      const labels = [
        '阴虚\n痰湿',
        '阴虚\n湿热\n夹瘀',
        '气虚\n痰湿',
        '气虚\n痰湿\n夹瘀',
        '气虚\n血瘀',
        '气虚\n湿热\n夹瘀',
        '湿热\n血瘀',
        '痰瘀\n互结',
        '表热\n里寒\n夹瘀',
        '气虚\n湿热',
        '表热\n里寒',
        '气虚\n脾气\n虚证',
      ]
      const currentIndex = this.calcIndex(labels, result)
      console.error('currentIndex', currentIndex)
      const total = labels.length;
      const slice = 360 / total;
      const startAngle = 270 + slice / 2, endAngle = -(270 + slice / 2)

      const deg1 = startAngle - slice * currentIndex - slice / 2;
      // console.error(deg1)
      const rad1 = deg1 * Math.PI / 180;
      const r1 = circleRadius - 3;
      const rotation1 = rad1 + Math.PI * 3 / 2;

      const steps = Math.ceil(labels.length / 2)
      const colors = generateGradientColors(steps)
      const colorIndex = currentIndex < steps ? currentIndex : (labels.length - 1 - currentIndex)
      // console.error(colorIndex)
      const polygonColor = colors[colorIndex];
      // console.error(polygonColor)
      const option = {
        backgroundColor: '#fff',
        series: [
          {
            name: 'arc',
            type: 'gauge',
            radius: greenRadius,
            startAngle,
            endAngle,
            axisLine: {
              lineStyle: {
                width: lineWidth,
                color: [[1, '#E0E0E080']]
              }
            },
            progress: {show: false},
            axisTick: {show: false},
            splitLine: {show: false},
            axisLabel: {show: false},
            pointer: {show: false},
            anchor: {show: false},
            detail: {show: false}
          },
          {
            name: 'green',
            type: 'gauge',
            radius: greenRadius,
            startAngle: startAngle - slice * currentIndex,
            endAngle: startAngle - slice * (currentIndex + 1),
            axisLine: {
              roundCap: true,
              lineStyle: {
                width: currentIndex >= 0 ? lineWidth : 0,
                color: [[1, '#56D173']]
              }
            },
            progress: {show: false},
            axisTick: {show: false},
            splitLine: {show: false},
            axisLabel: {show: false},
            pointer: {show: false},
            anchor: {show: false},
            detail: {show: false}
          }
        ],
        graphic: [
          {
            type: 'circle',
            left: 'center',
            top: 'center',
            shape: {r: circleRadius},
            style: {
              fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {offset: 0, color: '#FFB64D'},
                {offset: 1, color: '#EB5F5F'}
              ])
            }
          },
          {
            type: 'text',
            left: 'center',
            top: 'center',
            style: {
              text: `${result}\n体质`,
              textAlign: 'center',
              textVerticalAlign: 'middle',
              fontSize: 24,
              fontWeight: 'bold',
              fill: '#fff'
            }
          },
          // 小箭头旋转定位到高亮位置
          {
            type: 'polygon',
            shape: {
              points: [
                [0, -polygonWidth], [-polygonWidth, 0], [polygonWidth, 0]
              ]
            },
            position: [center + r1 * Math.cos(rad1), center - r1 * Math.sin(rad1)],
            rotation: rotation1,
            style: {
              fill: polygonColor
            }
          },
          ...labels.map((label, i) => {
            const deg = startAngle - slice * i - slice / 2;
            const rad = deg * Math.PI / 180;
            const r = wordRadius;
            return {
              type: 'group',
              position: [center + r * Math.cos(rad), center - r * Math.sin(rad)],
              rotation: rad + Math.PI * 3 / 2,
              children: [
                {
                  type: 'text',
                  style: {
                    text: label,
                    fontSize: this.clientWidth > 400 ? 30 : 16,
                    fill: '#333333a0',
                    textAlign: 'center',
                    textVerticalAlign: 'bottom'
                  },
                  position: [0, 0]
                }
              ]
            };
          })
        ]
      };

      const chart = echarts.init(document.getElementById('main2'));
      chart.setOption(option);

    },
    calcIndex(labels, result) {
      let currentIndex = labels.map(item => item.replaceAll('\n', '')).indexOf(result.replaceAll('(', "").replaceAll(")", ""))
      console.error('currentIndex', currentIndex)
      if (currentIndex < 0) {
        for (let i = 0; i < labels.length; i++) {
          const label = labels[i]
          if (result.includes(label)) {
            currentIndex = i
            break
          }
        }
      }
      return currentIndex;
    },
    renderChart3() {
      const echarts = this.$echarts
      const titles = ['苔色', '舌色', '苔质', '舌形', '津液']

      const {colorOfMossNames, colorOfTongueNames, mossNames, shapeOfTongueNames, bodyfluidNames} = this

      // console.error(this.chartWidth)
      const radius = this.chartWidth / 2 * 0.7
      const width = this.chartWidth / 12
      const gap = width
      const centerX = this.chartWidth / 2
      const centerY = this.chartWidth / 2
      const option = {
        backgroundColor: '#fff',
        title: {
          text: '舌面\n结果',
          left: 'center',
          top: '60%',
          textStyle: {
            fontSize: 24,
            fontWeight: 'bold',
            color: '#333',
            lineHeight: 30,
            align: 'center'
          }
        },
        series: [
          {
            name: '分段',
            type: 'gauge',
            radius: radius,
            center: [centerX, centerY],
            startAngle: 180,
            endAngle: 0,
            splitNumber: 5,
            axisLine: {
              roundCap: false,
              lineStyle: {
                width,
                color: [
                  [0.2, '#62B2B1'],
                  [0.4, '#8ABAD6'],
                  [0.6, '#A1D7E4'],
                  [0.8, '#369DC6'],
                  [1, '#2F72B0']
                ]
              }
            },
            axisTick: {show: false},
            splitLine: {show: false},
            axisLabel: {show: false},
            pointer: {show: false},
            detail: {show: false},
            anchor: {show: false}
          }
        ],
        graphic: [
          // 中心标签文字（每块中间）
          ...titles.map((text, i) => {
            const angle = 180 - i * 36 - 18; // 每项36度偏移，18为半宽度
            const rad = angle * Math.PI / 180;
            return {
              type: 'text',
              style: {
                text,
                fill: 'white',
                fontSize: 18,
                fontWeight: 'bold',
                textAlign: 'center',
                textVerticalAlign: 'middle',
              },
              position: [
                centerX + (radius - width / 2) * Math.cos(rad),
                centerY - (radius - width / 2) * Math.sin(rad)
              ],
              z: 10,
              rotation: rad + Math.PI * 3 / 2
            };
          }),
          // 外围分析说明
          ...[colorOfMossNames, colorOfTongueNames, mossNames, shapeOfTongueNames, bodyfluidNames].map((text, i) => {
            const angle = 180 - i * 36 - 18;
            const rad = angle * Math.PI / 180;
            return {
              type: 'text',
              style: {
                text: '• ' + text,
                fill: '#888',
                fontSize: 18,
                textAlign: 'center',
                textVerticalAlign: 'top'
              },
              position: [
                centerX + (radius + gap) * Math.cos(rad),
                centerY - (radius + gap) * Math.sin(rad)
              ]
            };
          })
        ]
      };

      const chart = echarts.init(document.getElementById('main3'));
      chart.setOption(option);
    },
    renderSymptoms() {
      console.error(this.predisposition)
      this.types = parseSymptoms(this.predisposition[0].message)
    },
    renderYinYang() {
      const result = getFixedConstitutionScore(this.id, this.diagnostic_results)
      if (result) {
        this.yinyang = [result.yin, result.yang]
        console.error(this.yinyang)
      }
    },
    print() {
      // this.capturePage()
      // alert('print')
    },
    capturePage() {
      var height = this.getFullHeight()
      console.error('fullHeight', height)
      html2canvas(document.body, {
        useCORS: true,
        scale: 2, // 提高清晰度
        backgroundColor: "#fff",
        windowWidth: document.documentElement.scrollWidth,
        windowHeight: height
      }).then(function (canvas) {
        var imgData = canvas.toDataURL("image/png");
        if (window.AndroidInterface && AndroidInterface.onImageReady) {
          AndroidInterface.onImageReady(imgData);
        }
      });
    },
    getFullHeight() {
      const allElements = Array.from(document.body.getElementsByTagName("*"));
      let maxBottom = 0;
      allElements.forEach(el => {
        const rect = el.getBoundingClientRect();
        const bottom = rect.top + rect.height + window.scrollY;
        if (bottom > maxBottom) maxBottom = bottom;
      });
      var body = document.body,
          html = document.documentElement;
      return Math.max(
          body.scrollHeight,
          body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight,
          Math.ceil(maxBottom),
          this.$refs.container.clientHeight
      );
    }
  },
}
</script>
<style scoped>
.pl30 {
  padding-left: 30px;
}

.fz28 {
  color: #000000;
  font-size: 30px;
}

.fz20 {
  font-size: 20px;
  color: #999999;
}

.p15 {
  padding: 10px;
}

.Recuperation {
  display: flex;
  align-items: center;
  margin-top: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  background: rgba(245, 245, 245, 1);
  border-radius: 15px;
}

.Recuperation > img {
  width: 120px;
  height: 120px;
  display: block;
  border-radius: 25px;
}

.explain {
  font-size: 28px;
  color: rgba(56, 56, 56, 1);
  padding: 20px 0;
}

.glossoscopyimg > img {
  width: 160px;
  height: 160px;
  display: block;
  border-radius: 50%;
}

.col9 {
  color: #999999;
}

.df {
  display: flex;
}

.jub {
  justify-content: space-between;
}

.pt30 {
  padding-top: 30px;
}

.coltt {
  color: #e9c7a0;
}

.al {
  align-items: center;
}

.fz25 {
  font-size: 25px;
}

.fz24 {
  font-size: 26px;
  color: #999999;
  line-height: 45px;
  padding-top: 30px;
}

.view_content_sub_header {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 72vw;
  height: 18vw;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url('../../assets/images/report_subtitle_bg.png');
}

.glossoscopytitle_two {
  font-size: 40px;
  color: #dc6666;
  font-weight: 650;
  text-align: center;
  /* border-bottom: 6px solid #e9c7a0; */
  /* width: 50px; */
  margin: 0 auto 30px auto;
  /* padding-bottom: 45px; */
}

.glossoscopytitle_one {
  display: flex;
  align-items: center;
}

.glossoscopytex {
  width: 30px;
  height: 30px;
  /* background-color: #000000; */
  /* border-radius: 50%; */
  display: block;
  margin-right: 10px;
}

.glossoscopyList {
  box-shadow: 3px 3px 5px 3px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  border-radius: 25px;
  padding: 30px;
  margin: 30px;
}

.glossoscopytitle {
  font-size: 26px;
  color: #000000;
  font-weight: 650;
}

.glossoscopy {
  background: white;
}

/deep/ .van-nav-bar .van-icon {
  color: black !important;
}

.assessment > img {
  width: 160px;
  height: 160px;
  display: block;
  border-radius: 50%;
}

.assessment {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.commentsItem {
  display: flex;
  justify-content: space-around;
  margin-top: -10vh;
}

.diagnostic_results_view {
  text-align: center;
  margin-top: 80px;
  margin-bottom: 40px;
}

.diagnostic_results_view span {
  padding: 8px 24px;
  border-radius: 38px;
  background: rgba(217, 250, 248, 1);

  font-size: 36px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: #e9c7a0;
  vertical-align: top;
}


.body-type-view {
  display: flex;
  justify-content: center;
  align-items: stretch; /* 拉伸高度 */
  padding: 40px 20px;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.05);
  height: 600px; /* 设置一个固定高度或父级撑开的高度 */
}

.body-type-view__side {
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* 关键点：按钮均匀分布撑满高度 */
  flex: 1;
  max-width: 180px; /* 控制按钮区宽度 */
}

.body-type-view__btn {
  background: #fff;
  padding: 10px 16px;
  border-radius: 80px;
  font-size: 24px;
  color: #333;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
}

.body-type-view__btn--active {
  background-color: #c95858;
  color: #fff;
  box-shadow: none;
}

.body-type-view__center {
  margin: 0 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.body-type-view__human {
  height: 100%;
  max-height: 100%;
  object-fit: contain;
}

</style>
